import { Brand } from "utility-types";

export type TimeZone = Brand<string, "timezone">;

export const EASTERN_TZ = "America/New_York" as TimeZone;

export const PACIFIC_TZ = "America/Los_Angeles" as TimeZone;

export const CENTRAL_TZ = "America/Chicago" as TimeZone;
